<template>
<m-pageframe
    title="TCR Brand & Campaign Registration"
>
<v-container
    fluid
    v-if="profile != null"
    style="padding-left: 15px; padding-right: 15px"
>
    <v-divider/>
        <h1 style="text-align: center; margin-top: 15px; margin-bottom: 15px">Brand Registration</h1>
    <v-divider
        style="margin-bottom: 15px"
    />

    <h2>Page 1: Brand Details</h2>

    <v-row>
        <v-col>
            <m-edit-text
                label="Legal Company Name"
                :value="profile.brand.legal_company_name"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="DBA or Brand Name, if different from legal name"
                :value="profile.brand.dba"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="What type of legal form is the organization?"
                :value="profile.brand.legal_form"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Country of Registration"
                :value="profile.brand.country"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="EIN"
                :value="profile.brand.ein"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="EIN Issuing Country"
                :value="profile.brand.ein_issuing_country"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="DUNS or GIIN or LEI Number"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="DUNS or GIIN or LEI Number"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="Address/Street"
                :value="profile.brand.address"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="City"
                :value="profile.brand.city"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="State"
                :value="profile.brand.state"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="ZIP Code"
                :value="profile.brand.zip"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="Country"
                :value="profile.brand.country"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Website/Online Presence"
                :value="profile.brand.website_provided_by_customer"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="Stock Symbol"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Stock Exchange"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="Vertical Type"
                :value="profile.brand.vertical"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Reference Id"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="First Name"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Last Name"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <m-edit-text
                label="Mobile Phone"
                :value="null"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
        </v-col>
    </v-row>

   <h2>Page 2: Brand Relationship</h2>

   <m-edit-text
        label="Brand Relationship"
        value="Key Accounts"
        read_only
        copy_check
    />

    <h2>Page 3: Contact Details</h2>

    <v-row>
        <v-col>
            <m-edit-text
                label="Support Email Address"
                :value="profile.brand.support_email_address"
                read_only
                copy_check
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Phone Number"
                :value="profile.brand.support_phone_number"
                read_only
                copy_check
            />
        </v-col>
    </v-row>

    <v-divider
        style="margin-top: 15px"
    />
        <h1 style="text-align: center; margin-top: 15px; margin-bottom: 15px">Campaign Registration</h1>
    <v-divider
        style="margin-bottom: 15px"
    />

    <h2 style="margin-top: 0px">Page 1: Use Case Selection</h2>

    <b>Select Brand</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Select Brand"
            :value="profile.brand_name"
            read_only
            copy_check
        />
    </div>

    <b>Select a Use-Case</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Use Case"
            value="Low Volume Mixed"
            read_only
            copy_check
        />

        <v-row
            style="max-width: 750px"
        >
            <v-col>
                <v-checkbox
                    label="2FA"
                    :value="false"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Customer Care"
                    v-model="checked"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Fraud Alert Messaging"
                    :value="false"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Marketing"
                    v-model="checked"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Public Service Announcement"
                    :value="false"
                    disabled
                    class="cb"
                />
            </v-col>
            <v-col>
                <v-checkbox
                    label="Account Notification"
                    v-model="checked"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Delivery Notification"
                    v-model="checked"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Higher Education"
                    :value="false"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Polling and voting"
                    :value="false"
                    disabled
                    class="cb"
                />
                <v-checkbox
                    label="Security Alert"
                    :value="false"
                    disabled
                    class="cb"
                />
            </v-col>
        </v-row>
    </div>

    <h2>Page 2: Carrier Terms Preview</h2>

    <p>
        There is nothing to edit on this page, accept the preview and continue.
    </p>

    <h2>Page 3: Campaign Details</h2>

    <b>Sample Messages</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Brand Name"
            :value="profile.brand_name"
            read_only
            copy_check
        />
    </div>

    <b>Campaign Details</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Use Case"
            :value="profile.use_case"
            read_only
            copy_check
        />
    
        <m-edit-text
            label="Campaign Description"
            :value="profile.campaign_description"
            read_only
            copy_check
        />

        <m-edit-text
            label="Call to Action"
            :value="profile.call_to_action"
            read_only
            copy_check
        />
    </div>

    <b>Sample Messages</b>
    <div
        class="sec"
    >
        <m-edit-text
            v-for="(item, index) in profile.sample_messages"
            :key="index"
            :label="'Sample Message '+(index+1)"
            :value="item"
            read_only
            copy_check
        />
    </div>

    <b>Subscriber Opt-in</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Opt In Keyword"
            :value="profile.opt_in_keyword"
            read_only
            copy_check
        />

        <m-edit-text
            label="Opt In Message"
            :value="profile.opt_in_message"
            read_only
            copy_check
        />
    </div>

    <b>Subscriber Opt-out</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Opt Out Keyword"
            :value="profile.opt_out_keyword"
            read_only
            copy_check
        />

        <m-edit-text
            label="Opt Out Message"
            :value="profile.opt_out_message"
            read_only
            copy_check
        />
    </div>

    <b>Subscriber Help</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Help Keywords"
            :value="profile.help_keywords"
            read_only
            copy_check
        />

        <m-edit-text
            label="Help Message"
            :value="profile.help_message"
            read_only
            copy_check
        />
    </div>

    <b>Number Pooling</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Number Pooling"
            value="No"
            read_only
            copy_check
        />
    </div>

    <b>Direct Lending or Loan Arrangement</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Direct Lending or Loan Arrangement"
            value="No"
            read_only
            copy_check
        />
    </div>

    <b>Embedded Link</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Embedded Link"
            value="Yes"
            read_only
            copy_check
        />
    </div>

    <b>Embedded Phone Number</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Embedded Phone Number"
            value="No"
            read_only
            copy_check
        />
    </div>

    <b>Age-Gated Content</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Age-Gated Content"
            :value="profile.age_gated_content"
            read_only
            copy_check
        />
    </div>

    <b>Terms &amp; Conditions</b>
    <div
        class="sec"
    >
        <m-edit-text
            label="Terms & Conditions"
            value="Yes"
            read_only
            copy_check
        />
    </div>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            profile: null,
            checked: true,
        }
    },

    mounted () {
        this.$rc.rest({
            'spinner': false,
            'endpoint': 'PUT: /api/v1/welcome/tcr-campaign-registration/get-profile',
        
            'params' : {
                    'organization_id': this.$route.params.organization_id,
                },
        
            'on_success': (data) => {
                    this.profile = data;
                },
        
            'on_error': 'Unable to get profile',
        });
    },
}
</script>

<style lang="scss" scoped>
.sec
{
    margin-left: 20px;
    margin-top: 5px;
    margin-bottom: 25px;
}
.cb
{
    margin-bottom: -25px;
}

h2
{
    margin-top: 40px;
}
</style>